import { ClearingHouseConfigurationScreen, SchemeConfigurationScreen } from '../features/superConfiguration/SuperConfigurationScreens';
import { TabbedItemPage } from './TabbedItemPage';
import { BusinessRecordScopedPage } from './BusinessRecordScopedPage';
import { createTenantSuperannuationSystemParametersClient, SuperannuationSystemParametersScreen } from '@pay-roadrunner/superannuation-system-parameters-ui';
import { authFetch } from '../auth/authFetch';
import { getApiBaseUrl } from '../auth/api';

const systemParametersClient = createTenantSuperannuationSystemParametersClient({ getBaseUrl: getApiBaseUrl, fetchImpl: authFetch });

export const MaintenanceSuperannuationPage = () => (
  <TabbedItemPage
    itemPath="/maintenance/superannuation"
    preserveSearch
    tabContentOverrides={{
      'clearing-house-configuration': <BusinessRecordScopedPage>{({ businessRecordId }) => <ClearingHouseConfigurationScreen businessRecordId={businessRecordId} />}</BusinessRecordScopedPage>,
      'scheme-configuration': <BusinessRecordScopedPage>{({ businessRecordId, inactive }) => <SchemeConfigurationScreen businessRecordId={businessRecordId} readOnly={inactive} />}</BusinessRecordScopedPage>,
      'system-parameters': <BusinessRecordScopedPage>{({ businessRecordId }) => <SuperannuationSystemParametersScreen client={systemParametersClient} businessRecordId={businessRecordId} readOnly />}</BusinessRecordScopedPage>,
    }}
  />
);
